enum DefaultActivityTypeName {
  CALL = "Call",
  COACHING_TASK = "Coaching Task",
  EMAIL = "Email",
  LUNCH = "Lunch",
  MEETING = "Meeting",
  TASK = "Task",
  TEXT = "Text",
  VISIT = "Visit",
}

export default DefaultActivityTypeName;
